/**
 * SSR-secure ID generator for UI components
 *
 * Uses Nuxt's built-in useId() for guaranteed
 * Server/client ID consistency without hydration errors.
 *
 * @param type - Component type (e.g., ‘input’, ‘checkbox’, ‘modal’)
 * @returns SSR-secure, unique ID
 *
 * @example
 * const inputId = useComponentId('input')  // → 'ninput-0'
 * const modalId = useComponentId('modal')  // → 'nmodal-0'
 */
export const useComponentId = (type: string): string => {
  const id = useId()
  return `${type}-${id}`
}
